export default __webpack_public_path__ + "static/media/screen2.f2df8b69.png";